import { createSlice } from '@reduxjs/toolkit';

const {
  id,
  name,
  timezone,
  email,
  new_airbo: newAirbo,
  public_slug: publicSlug,
  is_public: isPublic,
} = JSON.parse(document.body.dataset.currentBoard);

const initialState = {
  id,
  name,
  timezone,
  email,
  newAirbo,
  publicSlug,
  isPublic,
};

const currentBoardSlice = createSlice({
  name: 'currentBoard',
  initialState,
});

export default currentBoardSlice.reducer;
